"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resetPasswordValidator = (0, _validation.createValidator)({
  email: [_validation.required, _validation.email]
});
exports.default = (0, _lruMemoize2.default)(10)(resetPasswordValidator);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Password/resetPasswordValidator.js
 ** module id = 1227
 ** module chunks = 0
 **/